/**
 * QuickStartTemplates Component
 * 
 * Animated template chips with hover expansion
 * Following SOLID principles:
 * - Single Responsibility: Manages template selection and display
 * - Open/Closed: Extensible through props without modification
 * - Interface Segregation: Only exposes necessary props
 */

import React from 'react';
import { Tag, Popconfirm, Space, Typography } from 'antd';
import { QuickStartTemplatesProps, TemplateData } from '../../../types/Step0.types';
import { quickStartTemplates } from './templates';
import './index.scss';

/**
 * QuickStartTemplates Component
 * 
 * Features:
 * - 4 template chips in responsive grid
 * - Hover expansion animation (120px → 400px)
 * - Smooth transitions with cubic-bezier easing
 * - Click to pre-fill prompt
 * - Mobile-responsive (2x2 grid on small screens)
 */
const QuickStartTemplates: React.FC<QuickStartTemplatesProps> = ({
    onTemplateSelect,
}) => {
    const handleTemplateClick = (template: TemplateData) => {
        onTemplateSelect(template);
    };

    const renderTemplateChip = (template: TemplateData) => {

        return (
            <Popconfirm
                key={template.id}
                title={
                    <div className="template-popconfirm-content">
                        <div className="template-popconfirm-description">
                            <div className="description-content">
                                {template.description.split('\n').map((line, index) => (
                                    <div key={`${template.id}-line-${index}`} className="description-line">
                                        {line}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                }
                onConfirm={() => handleTemplateClick(template)}
                okText="Use Template"
                cancelText="Cancel"
                placement="top"
                trigger="hover"
                icon={false}
            >
                <Tag
                    className="template-chip"
                    style={{ cursor: 'pointer' }}
                >
                    {template.title}
                </Tag>
            </Popconfirm>
        );
    };

    return (
        <div className="quick-start-templates">
            <div className="templates-header">
                <Typography.Text type="secondary" className="templates-title">
                    Try these sample prompts to get started
                </Typography.Text>
            </div>

            <Space wrap size="middle" className="templates-grid" style={{ justifyContent: 'center' }}>
                {quickStartTemplates.map(renderTemplateChip)}
            </Space>
        </div>
    );
};

export default QuickStartTemplates;
